/**
 * @flow
 * @author: Vishnu
 */
import React, { Component } from 'react'
import {
  TermsAndConditionsContainer,
  ContentContainer,
  TitleContainer,
  TnCTitle,
  TnCContent
} from './styledComponents'

type Props = {}

class TermsAndConditions extends Component<Props> {
  render() {
    const { termsAndConditionsData } = this.props
    const { heading, description } = termsAndConditionsData
    return (
      <TermsAndConditionsContainer>
        <div>
          <TitleContainer>
            <TnCTitle
              dangerouslySetInnerHTML={{
                __html: decodeURIComponent(escape(heading))
              }}
            />
          </TitleContainer>
          <ContentContainer className="tnc-scroll-bar">
            <TnCContent
              dangerouslySetInnerHTML={{
                __html: description
              }}
            />
          </ContentContainer>
        </div>
      </TermsAndConditionsContainer>
    )
  }
}

export default TermsAndConditions



// WEBPACK FOOTER //
// ./src/components/FormHomePage/TermsAndConditions.js